// extracted by mini-css-extract-plugin
module.exports = {"News":"Video_News__xE2ko","Title":"Video_Title__1_Qh3","Project":"Video_Project__2Oj0H","ProjectBold":"Video_ProjectBold__1lpc_","listStyle":"Video_listStyle__J1k9t"};